import axios from "axios";
import { config } from "./token";
import { url } from "./url";

const api = axios.create({
  baseURL: `${url}/site`,
  timeout: 15000,
});

export const getSites = (countries) => api.get(`/`, { params: { countries } });
export const getDonorSites = (countries) =>
  api.get(`/donor`, { ...config(), params: { countries } });
export const getSiteCurrentStock = (site) =>
  api.get(`/currentStock/${site}`, config());
export const getSiteName = (value) => api.get(`/siteName/${value}`, config());

export const getSiteInfo = (value) => api.get(`/siteInfo/${value}`, config());
